import React from "react";
import "./style.css";

export default function Spinner() {
  return (
    <div className="spinner-container">
      <img
        src="https://www.image.sporthood.in/videos/spinner.gif"
        alt="loading..."
        className="spinner-image"
      />
    </div>
  );
}
